import BodyDisplay from "./BodyDisplay";
import Context from "./Context";


export default function DisplayDadosClienteFormulario(props: DisplayDadosClienteFormularioProps) {

    return (
        <>
            {props.tipoDado === "context" && <Context />}
            {props.tipoDado === "param" && <BodyDisplay tipo={props.tipo} codigo={props.codigo} />}
        </>
    );
}

interface BaseProps {
    tipoDado: "context" | "param";
}

interface ContextProps extends BaseProps {
    tipoDado: "context";
}

interface ParamProps extends BaseProps {
    tipoDado: "param";
    tipo: string;
    codigo: number;
}

export type DisplayDadosClienteFormularioProps = ContextProps | ParamProps;